import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/_services/utils.service';
import { Carrusel, User } from 'src/app/_models'
import { TranslateService } from '@ngx-translate/core';
import { ApplicationStateService } from 'src/app/_services/application-state.service';
import { environment } from 'src/environments/environment.prod';
import { AuthenticationService, HeaderService } from 'src/app/_services';


declare const $ : any ;

@Component({
  selector: 'app-slide',
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.css']
})

export class SlideComponent implements OnInit {

  public topLeftCarrusel : Carrusel; 
  public topRightCarrusel : Carrusel; 
  public slideCarrusel : Carrusel; 
  public rightTopCarrusel1 : Carrusel; 
  public rightTopCarrusel2 : Carrusel; 
  public rightBottomCarrusel1 : Carrusel; 
  public rightBottomCarrusel2 : Carrusel; 

  
  public showSlide : boolean;
  public currentUser: User;

  constructor(
    private header : HeaderService,
    private translate : TranslateService,
    private utils : UtilsService,
    private apps : ApplicationStateService,
    private auth: AuthenticationService,
  ) {

    this.auth.currentUser.subscribe(x => this.currentUser = x);

    this.header.showSlide.subscribe( s => {
      this.showSlide = s;
      setTimeout(() => {
        if (this.showSlide){
            $('.carousel').carousel('cycle');
            $(document).trigger('initCarousel');
        }
      }, environment.READY_TIMEOUT);
    });

    // No necessari
    // this.apps.onResize$.subscribe(result => {
    //   this.updateCarrusels();
    // });

    this.translate.onLangChange.subscribe(params =>{
      this.updateCarrusels();
    });


  }

  ngOnInit() {
    // No necessari
    // this.updateCarrusels();
  }


  updateCarrusels(){
    if (this.apps.isMobileResolution){
      this.utils.getCarrusel(7,this.translate.currentLang).subscribe(result =>{
        this.slideCarrusel = result;
        this.utils.getCarrusel(15,this.translate.currentLang).subscribe(result =>{
          this.topLeftCarrusel = result;
          this.utils.getCarrusel(18,this.translate.currentLang).subscribe(result =>{
            this.topRightCarrusel = result;
          });
        });
      });
      this.rightTopCarrusel1 = null;
      this.rightTopCarrusel2 = null;
      this.rightBottomCarrusel1 = null;
      this.rightBottomCarrusel1 = null;
    } else {
      this.utils.getCarrusel(3,this.translate.currentLang).subscribe(result =>{
        this.slideCarrusel = result;
        this.utils.getCarrusel(14,this.translate.currentLang).subscribe(result =>{
          this.rightTopCarrusel1 = result;
          this.utils.getCarrusel(17,this.translate.currentLang).subscribe(result =>{
            this.rightTopCarrusel2 = result;
          }); 
        }); 
        this.utils.getCarrusel(4,this.translate.currentLang).subscribe(result =>{
          this.rightBottomCarrusel1 = result;
          this.utils.getCarrusel(5,this.translate.currentLang).subscribe(result =>{
            this.rightBottomCarrusel2 = result;
          });
        }); 
      });
      this.topLeftCarrusel = null;
      this.topRightCarrusel = null;
    }
  }
}
